import { Box, Separator, Text, VStack } from "@chakra-ui/react-v3";
import { DocumentsSection } from "../components/side-panel-sections/documents-section";
import { SidePanelLayout } from "../components/side-panel-sections/side-panel-layout";
import { CareTeamRowData } from "../tables/care-team/care-team-rows";

export type CareTeamSidePanelContentProps = {
  data: CareTeamRowData;
};

export function CareTeamSidePanelContent({ data }: CareTeamSidePanelContentProps) {
  return (
    <SidePanelLayout title="Care Team Member" subtitle={data.name}>
      <VStack align="stretch" gap={4}>
        <DetailRow label="Specialty" value={data.specialty} />
        <DetailRow label="Phone" value={data.phone} />
        <DetailRow label="Email" value={data.email} />
        <DetailRow label="Address" value={data.address} />
        <DetailRow label="Last Appointment" value={data.mostRecentAppointment} />
      </VStack>

      <Separator borderColor="border" />

      <DocumentsSection resources={[data.originalData]} resourceType="Practitioner" />
    </SidePanelLayout>
  );
}

function DetailRow({ label, value }: { label: string; value: string }) {
  return (
    <Box>
      <Text fontSize="sm" color="fg.muted" fontWeight="medium">
        {label}
      </Text>
      <Text fontSize="md" color="fg">
        {value}
      </Text>
    </Box>
  );
}
